import {
    InputLabel
} from "@mui/material";
import CheckboxField from "./CheckboxField";
import { SelectOption } from "./SelectField";
import { InputFieldProps } from "../../../models/Interfaces";



export interface CheckboxSelectFieldProps extends InputFieldProps {
    options: SelectOption[];
    multiple?: boolean;
}


const CheckboxOption = ({option, multiple, selectedValues, onChange}) => {

    // Disabled also if all children are disabled
    var disabled = option.disabled || (option?.children?.length && !option?.children.find(c => !c.disabled))

    return (
        <>
            {(multiple) || (!multiple && !option.children?.length) ? (
                <CheckboxField
                    formik
                    name={option.value}
                    label={option.label}
                    disabled={disabled}
                    warning={false}
                    value={selectedValues.includes(option.value)}
                    onChange={onChange}  />
            ) : (
                <small style={{marginBottom: "5px"}}>{option.label}</small>
            )}
            
            {option.children ? (
                <div className="checkbox-select-list" style={{paddingLeft: "18px"}}>
                    {option.children?.map((child, i) => <CheckboxOption key={i} multiple={multiple} option={child} selectedValues={selectedValues} onChange={onChange} />)}
                </div>
            ) : null}
        </>
    )
}


export const CheckboxSelectField = ({

    name,
    value = [],
    label = "",
    options,
    onChange,
    multiple = true,
    warning = "",
    helpText = "",
    formik = false,
    disabled = false,
    autoFocus = false,
    placeholder = "",

}: CheckboxSelectFieldProps) => {

    const getOptionByValue = (optionsList, value): any => {
        
        for (var i = 0; i < optionsList.length; i++) {

            var option = optionsList[i]
        
            if (option.value === value) {
                return option
            } 

            if (option.children) {
                var valueFromChild = getOptionByValue(option.children, value)

                if (valueFromChild) {
                    return valueFromChild
                }
            }
        }

        return null
    }

    const getChildValues = (value) => {

        var values = [value]
        var option = getOptionByValue(options, value)
        
        option?.children?.forEach((child) => {
            values.push(...getChildValues(child.value))
        })

        return values
    }

    const handleChange = (e) => {

        var newValue = null
        
        if (!multiple) {
            newValue = e.target.name
        } else {
            var selectedValues = getChildValues(e.target.name)

            if (value.includes(e.target.name)) { // Remove
                newValue = value.filter(v => !selectedValues.includes(v))

            } else { // Add
                newValue = [...value, ...selectedValues]
            }

            // Remove duplicate values
            newValue = Array.from(new Set(newValue))
        }

        if (!formik) {
            onChange({name: name, value: newValue})
            return 
        }

        var eventProx: any = {
            target: {
                name: name,
                value: newValue,
                type: "string"
            }
        }

        onChange(eventProx)
    }

    var classes = "form-field field-checkbox-select"
    classes = disabled ? `${classes} disabled` : classes

    return (
        <div className={classes}>

            {label ? <InputLabel>{label}</InputLabel> : null}

            <div className="checkbox-select-list">
                {options.map((option, i) => <CheckboxOption key={i} multiple={multiple} option={option} selectedValues={multiple ? value : [value]} onChange={handleChange} /> )}
            </div>

            {warning !== false && typeof warning === "string" ? <span className="warning">{warning}</span> : null}

            {helpText ? <span className="help-text">{helpText}</span> : null}

        </div>
    )
}